module.exports = __webpack_public_path__ + "img/about_4.d176c32a.png";